import { t } from 'i18n';
import React, { useState } from 'react';
import { NewsFeedEntity } from 'types';
import { getDateStringWithFormat } from '@teko/ui-cart';
import { NewsMagazine } from '../../../components/desktop/pages/NewsMagazine';
import { HeadSection } from 'components/HeadSection';
import { useTenantConfig } from 'contexts';
import { stripHtmlString } from '../utils';
import { useNewsFeed } from 'hooks';
import { useRouter } from 'next/router';
import {
  Breadcrumbs,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  styled,
  Button,
  Container,
} from '@teko/ds-desktop';

interface NewsDetailProps {
  news: NewsFeedEntity;
}
const StyledContainer = styled(Container)`
  min-height: 70vh;
`;
const NewsWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  padding: 1rem;
`;
const NewsTitle = styled.h1`
  font-size: 1.5rem;
  line-height: 30px;
  margin-bottom: 10px;
  font-weight: 400;
`;
const NewsDate = styled.div`
  font-size: 0.85625rem;
`;
const NewsContent = styled.div`
  margin-top: 10px;
  img {
    max-width: 100%;
  }
`;
const StyledButton = styled(Button)`
  height: 36px;
  padding: 0 20px;
  min-width: 100px;
`;
export function NewsFeedDetail({ news: ssrNews }: NewsDetailProps) {
  const { query } = useRouter();
  const { news: newsList } = useNewsFeed({
    ssrNews: [ssrNews],
    feedId: String(query.slug),
  });
  const news = newsList?.[0];
  const images = news?.content?.match(/<figure class="image">.*?<\/figure>/g);
  const [error, setError] = useState(true);
  const { baseDomain, canonicalDomain } = useTenantConfig();
  if (!news) {
    return null;
  }
  return (
    <>
      <HeadSection
        canonical={`${canonicalDomain || baseDomain}/tin-tuc/${news.urlKey}`}
        title={news.metaTitle || news.name}
        image={news?.imageUrl}
        description={
          news.metaDescription ||
          stripHtmlString(news.content || '').substr(0, 155)
        }
      />
      <StyledContainer marginTop="s16" marginBottom="s16">
        <Breadcrumbs
          breadcrumbs={[
            {
              name: t('Trang chủ'),
              link: '/',
            },
            {
              link: '/tin-tuc',
              name: t('Tin tức'),
            },
            {
              disabled: true,
              link: '#',
              name: news?.name || '',
            },
          ]}
        />
        <NewsWrapper>
          <NewsTitle>{news.name}</NewsTitle>
          <NewsDate>{getDateStringWithFormat(news?.updateAt || '')}</NewsDate>
          <NewsContent>
            {news.isMagazine && images ? (
              <NewsMagazine images={images} />
            ) : news.isMagazine && !images ? (
              <Modal
                width="400px"
                visible={error}
                showCloseIcon={false}
                footer={false}
              >
                <ModalHeader>{t('Có lỗi xảy ra')}</ModalHeader>
                <ModalBody>
                  {t('Bài viết không đúng định dạng magazine.')}
                </ModalBody>
                <ModalFooter>
                  <StyledButton
                    variant="primary"
                    onClick={() => {
                      setError(false);
                    }}
                  >
                    {t('Đóng')}
                  </StyledButton>
                </ModalFooter>
              </Modal>
            ) : (
              <div
                className="contentWrapper"
                dangerouslySetInnerHTML={{ __html: news.content || '' }}
              />
            )}
          </NewsContent>
        </NewsWrapper>
      </StyledContainer>
    </>
  );
}
